import { atom } from 'recoil';

export interface DicListInterface {}

export const dicListAtom = atom<DicListInterface | null>({
  key: 'dicList',
  default: null
});
